import React from 'react';
import PropTypes from 'prop-types';

const RadioCash = ({ optionName }) => {
  return (
    <div className="radio RadioCash">
      <div className="radioItem">
        <input type="radio" name="radio-cash" className="radio-input" id="cashRadio-1" checked={true} readOnly />
        <label htmlFor="cashRadio-1">{optionName}</label>
      </div>
    </div>
  );
};


RadioCash.defaultProps = {
  optionName: 'クレジットカード',
};

RadioCash.propTypes = {
  optionName: PropTypes.string,
};

export default RadioCash;
